module.exports = __webpack_public_path__ + "static/media/03-codificacao.a431ca7d.png";